import { Controller } from "@hotwired/stimulus"
import Logger from '../lib/logger'

export default class extends Controller {
  connect() {
    Logger.debug('Distance sort controller connected')
    this.initializeButtonState()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const field = this.getFieldElement()
    const isActive = field.value === 'true'
    
    if (isActive) {
      // Currently sorting by distance, turn it off
      field.value = ''
      this.updateButtonState(false)
    } else {
      // Not sorting by distance, turn it on
      field.value = 'true'
      this.updateButtonState(true)
    }
    
    // Submit the form using Turbo to prevent page redirection
    this.submitForm()
  }

  getFieldElement() {
    // Find the hidden field by name
    return document.querySelector('input[name="sort_by_distance"]')
  }

  getFormElement() {
    // Find the form by ID
    return document.getElementById('bids_search')
  }

  updateButtonState(isActive) {
    if (isActive) {
      this.element.classList.remove('btn-outline-info')
      this.element.classList.add('btn-info')
      this.element.title = 'Currently sorting by distance - click to turn off'
    } else {
      this.element.classList.remove('btn-info')
      this.element.classList.add('btn-outline-info')
      this.element.title = 'Sort by distance from map center'
    }
  }

  initializeButtonState() {
    const field = this.getFieldElement()
    if (field && field.value === 'true') {
      this.updateButtonState(true)
    }
  }

  submitForm() {
    const form = this.getFormElement()
    if (!form) return
    
    // Use Turbo to submit the form without page redirection
    const formData = new FormData(form)
    const url = new URL(form.action, window.location.origin)
    
    // Add form data to URL for GET request
    for (const [key, value] of formData.entries()) {
      url.searchParams.set(key, value)
    }
    
    // Use Turbo.visit to navigate without full page reload
    Turbo.visit(url.toString(), {
      frame: "bidscrm"
    })
  }
}
